export const ORGANIZATION_CONFIG_QUERY_KEYS = {
  base: ["organizationConfig"] as const,
  color: ["organizationColor"] as const
};
